import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadResponse } from '../../../models/files.interface';
import { environment } from '../../../../environments/environment';
const URL_BASE = environment.BACKEND_API;
@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private readonly http: HttpClient) {}

  buscarAquivoPorId(idArquivo: number): Observable<Blob> {
    return this.http.get(URL_BASE + '/custom-files/' + idArquivo, {
      responseType: 'blob',
    });
  }

  /**
   *
   * @param file é o arquivo que quer salvar
   * @param entityId é o id da entidade que sera vinculado o arquivo
   * @param contentType é o identificador da entidade que voce quer vincular o arquivo
   * @param field seria o tipo, tem material, foto, logo, pdf, conteudo
   * @param folder é a pasta onde será salva o arquivo, sempre se atentar porque tem o padrão que vai ser usado
   * @returns
   */
  uploadFile(
    file: File,
    entityId: number,
    contentType: string,
    field: string,
    folder: string,
  ): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('entityId', String(entityId));
    formData.append('contentType', contentType);
    formData.append('field', field);
    formData.append('folder', folder);

    return this.http.post<UploadResponse>(
      `${URL_BASE}/custom-upload`,
      formData,
    );
  }

  deletarArquivoPorId(id: number): Observable<void> {
    return this.http.delete<void>(URL_BASE + '/custom-files/' + id);
  }
}
